var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 200px)"}},[_c('b-overlay',{staticClass:"h-100",attrs:{"show":_vm.isLoading,"rounded":"sm"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.source}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }